import { render, staticRenderFns } from "./AccessNavTabs.vue?vue&type=template&id=9170cff8&"
import script from "./AccessNavTabs.vue?vue&type=script&lang=js&"
export * from "./AccessNavTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports